export { default as WaLogin } from "./View";
export { default as RequireLogin } from "./RequireLoginView";